export const formatNumberWithKilo = (num = 0) => {
  return new Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 1,
    compactDisplay: 'short',
  }).format(num)
}

export const formatDuration = (seconds: number) => {
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  const s = Math.floor(seconds % 60)

  const hStr = h.toString().padStart(2, '0')
  const mStr = m.toString().padStart(2, '0')
  const sStr = s.toString().padStart(2, '0')

  if (h > 0) {
    return `${hStr}:${mStr}:${sStr}`
  }

  return `${mStr}:${sStr}`
}
